import dayjs from 'dayjs'
import * as Yup from 'yup'
import { CheckoutStepKeys } from './steps'
import { isValidIBAN } from 'ibantools'

interface ValidationMessages {
  general: string
  invalidIban: string
  noneGermanIban: string
  over18: string
  postalCodeTypeError: string
  payment: string
}

export const makeValidationSchema = (messages: ValidationMessages) => ({
  [CheckoutStepKeys.payment]: Yup.object().shape({
    payment: Yup.object().required(messages.general),
    iban: Yup.string()
      .required(messages.general)
      .test('is-valid-iban', messages.invalidIban, (value) => {
        if (!value) return false
        return isValidIBAN(value)
      })
      .test(
        'is-german-iban',
        messages.noneGermanIban,
        (value) => (value && value.startsWith('DE')) || false,
      ),
    name: Yup.string().required(messages.general),
  }),
  [CheckoutStepKeys.poa]: Yup.object().shape({
    fullname: Yup.string().trim().required(messages.general),
    birthdate: Yup.number()
      .required(messages.general)
      .test(
        'olderThan18',
        messages.over18,
        (value) => dayjs().diff(dayjs(value), 'years') >= 18,
      )
      .typeError(messages.general),
    signature: Yup.string().required(messages.general),
  }),
  [CheckoutStepKeys.overview]: Yup.object().shape({
    insuranceTerms: Yup.boolean()
      .required(messages.general)
      .oneOf([true], messages.general),
  }),
  [CheckoutStepKeys.companyDetailsAndPayment]: Yup.object().shape({
    companyDetails: Yup.object().shape({
      address: Yup.object()
        .shape({
          city: Yup.string().required(messages.general),
          postalCode: Yup.number()
            .required(messages.general)
            .typeError(messages.postalCodeTypeError),
          street: Yup.string().required(messages.general),
          streetNr: Yup.string()
            .required(messages.general)
            .typeError(messages.general),
        })
        .typeError(messages.general),
    }),
    sepa: Yup.boolean()
      .required(messages.general)
      .oneOf([true], messages.general),
    newPaymentName: Yup.string().required(messages.general),
    newPaymentIban: Yup.string()
      .required(messages.general)
      .test('is-valid-iban', messages.invalidIban, (value) => {
        if (!value) return false
        return isValidIBAN(value)
      }),
    newPaymentIsDefault: Yup.boolean().required(messages.general),
    payment: Yup.object().shape({
      paymentId: Yup.string().required(messages.payment),
    }),
  }),
})
